import type LegalEntity from 'modules/core/store/models/LegalEntity'

import type Employee from '../models/Employee'
import type EmployeeGroup from '../models/EmployeeGroup'
import { legalEntityEmployeeGroups } from './employeeGroups'
import employees from './employees'

const employeeGroupEmployees = (employeeGroup: EmployeeGroup) => {
  return employees.filter({
    employee_group_id: employeeGroup.attributes.id,
  })
}

export const legalEntityEmployees = (legalEntity: LegalEntity) => {
  return legalEntityEmployeeGroups(legalEntity).reduce(
    (memo: Employee[], employeeGroup: EmployeeGroup) =>
      memo.concat(employeeGroupEmployees(employeeGroup)),
    []
  )
}
